import { Observer } from "mobx-react";

import QuestionnaireStore from "../../stores/QuestionnaireStore";
import { getMobileOperatingSystem } from "../../../constants/utils";
import Styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";

const Footer = () => {
  const isiOS = getMobileOperatingSystem() === "iOS";

  return (
    <Observer>
      {() => {
        const isNextDisabled = QuestionnaireStore.isNextButtonDisabled();
        const isBackDisabled = QuestionnaireStore.currentQuestionIndex == 0;

        return (
          <div>
            <input
              type="button"
              value="back"
              className={isiOS ? iStyles.BackBtn : Styles.BackBtn}
              style={{ opacity: isBackDisabled ? 0.5 : 1 }}
              disabled={isBackDisabled}
              onClick={QuestionnaireStore.handleBackPress}
            />
            <input
              type="button"
              value="next"
              className={isiOS ? iStyles.NextBtn : Styles.NextBtn}
              style={{ opacity: isNextDisabled ? 0.5 : 1 }}
              disabled={isNextDisabled}
              onClick={QuestionnaireStore.handleNextPress}
            />
          </div>
        );
      }}
    </Observer>
  );
};

export default Footer;
